/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface RoleResponseDto {
  createdUserId: string;
  createdUsername: string;
  createdAt: Date;
  updatedUserId: string;
  updatedUsername: string;
  updatedAt: Date;
  deletedUserId: string;
  deletedUsername: string;
  deletedAt: Date;
  id: string;
  name: string;
  description: string;
  type: RoleResponseDto.TypeEnum;
  subSystem: RoleResponseDto.SubSystemEnum;
  isActive: boolean;
}
// tslint:disable-next-line:no-namespace
export namespace RoleResponseDto {
  export type TypeEnum = 'admin' | 'member';
  export const TypeEnum = {
      Admin: 'admin' as TypeEnum,
      Member: 'member' as TypeEnum,
  };
  export type SubSystemEnum = 'enterprise_web_admin' | 'enterprise_tablet_app' | 'member_app';
  export const SubSystemEnum = {
      EnterpriseWebAdmin: 'enterprise_web_admin' as SubSystemEnum,
      EnterpriseTabletApp: 'enterprise_tablet_app' as SubSystemEnum,
      MemberApp: 'member_app' as SubSystemEnum,
  };
}
